module.exports = __webpack_public_path__ + "static/media/Eventxtra Virtual Platform_v8-19.0dd6acfd.png";